import { cn } from '@/lib/utils';

type Status = 'red' | 'yellow' | 'green' | 'blue';

interface StatusBannerProps {
  status: Status;
  message: string;
  statusStyles?: Record<Status, string>;
}

const DEFAULT_STATUS_STYLES: Record<Status, string> = {
  red: 'bg-red-100 border-l-4 border-l-red-500 text-red-800',
  yellow: 'bg-yellow-100 border-l-4 border-l-yellow-500 text-yellow-800',
  green: 'bg-green-100 border-l-4 border-l-green-500 text-green-800',
  blue: 'bg-blue-100 border-l-4 border-l-blue-500 text-blue-800',
};

export function StatusBanner({
  status,
  message,
  statusStyles = DEFAULT_STATUS_STYLES,
}: StatusBannerProps) {
  return (
    <div className={cn('p-4 rounded-md', statusStyles[status])}>
      <p className="text-sm">{message}</p>
    </div>
  );
}
